
import VueTypes from 'vue-types';
import Loading from 'vue-loading-overlay';

export default {
    name: 'MyPreloader',
    components: {
        Loading
    },
    props: {
        maxSize: {
            type: Number,
            default: 120
        },
        maxSizeMobile: {
            type: Number,
            default: 80
        },
        color: VueTypes.string
    },
    data() {
        return {
            windowWidth: 1920,
            userTheme: 'light_theme'
        };
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth;
        },
        changePreloaderSize() {
            return this.windowWidth <= 480 ? this.maxSizeMobile : this.maxSize;
        }
    },
    mounted() {
        this.userTheme = document.documentElement.classList.contains('light-theme') ? 'light_theme' : 'dark_theme';
        this.windowWidth = window.innerWidth;
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
    }
};
